import React from 'react';
import ReactDOM from "react-dom/client";
import App from './router';

import { AuthProvider } from './context/auth';
import MessageProvider from "./context/message";
import GlobalNotificationMessage from "./components/global-notification-message";

ReactDOM.createRoot(document.getElementById("app")).render(
    <React.StrictMode>
        <AuthProvider>
          <MessageProvider>
            <GlobalNotificationMessage />
            <App />
          </MessageProvider>
        </AuthProvider>
    </React.StrictMode>
);
